import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { TrashIcon } from "@heroicons/react/24/outline";
import { Checkbox, CheckboxField } from "V2.0/common/checkbox";
import { Label } from "V2.0/common/fieldset";
import { message } from "antd";
import { deleteBulkCampaigns } from "V2.0/services/campaignService";
import { showErrorToast } from "V2.0/utils";

function useCheckbox() {
  const [isChecked, setIsChecked] = useState(false);

  const Field = ({ label }) => (
    <CheckboxField>
      <Checkbox
        onChange={() => setIsChecked((prevState) => !prevState)}
        checked={isChecked}
      />
      <Label>{label}</Label>
    </CheckboxField>
  );

  return {
    isChecked,
    Field,
  };
}

export default function BulkDelete(props) {
  const { totalItems, appliedFilters, workspaceId, refetchFilteredCampaigns } =
    props;

  const [openBulkDelete, setOpenBulkDelete] = useState(false);
  const { isChecked, Field: CheckBox } = useCheckbox();
  const [loading, setLoading] = useState(false);

  const handleConfirmBulkDelete = async () => {
    setLoading(true);
    message.loading(`Deleting ${totalItems} campaigns`);

    const { startDate, endDate, filterAssistantId, callStatus } =
      appliedFilters;
    const payload = {
      ...(Boolean(startDate) ? { startDate } : {}),
      ...(Boolean(endDate) ? { endDate } : {}),
      ...(Boolean(filterAssistantId) ? { assistantId: filterAssistantId } : {}),
      ...(Boolean(callStatus) ? { callStatuses: [callStatus] } : {}),
    };

    console.log({ payload });

    try {
      const response = await deleteBulkCampaigns({ workspaceId, payload });

      if (response.status === 200) {
        setLoading(false);
        message.destroy();
        message.success(`${totalItems} Campaigns deleted`);
        setOpenBulkDelete(false);
        refetchFilteredCampaigns();
      }
    } catch (e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Campaigns deletion failed");
    }
  };

  return (
    <>
      <Button color="red" onClick={() => setOpenBulkDelete(true)}>
        <TrashIcon />
        Delete {totalItems} campaigns
      </Button>
      <Dialog open={openBulkDelete} onClose={() => {}}>
        <DialogTitle>Delete {totalItems} campaigns ?</DialogTitle>
        <DialogBody>
          <CheckBox label="Confirm deletion" />
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setOpenBulkDelete(false)}>
            Cancel
          </Button>
          <Button
            color="red"
            onClick={handleConfirmBulkDelete}
            loading={loading}
            disabled={!isChecked}
          >
            <TrashIcon /> Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
